import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { Storage } from '@ionic/storage';
import { StorageConfigProvider } from './storage-config.provider';
import { Usuario } from '../models/usuario';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class UsuarioProvider {

    private usuario: Usuario;

    private isLoaded: boolean;

    private usuarioBehavior = new BehaviorSubject<Usuario | null>(null);

    formattedTime = '00:00:00';

    constructor(
        private storage: Storage,
        private storageConfig: StorageConfigProvider
    ) {

    }

    async isAutenticado(): Promise<boolean> {
        if (!this.isLoaded) {
            await this.load();
            this.isLoaded = true;
        }
        return Promise.resolve(this.usuario != null);
    }

    getUsuario(): Usuario {
        return this.usuario;
    }

    getUsuarioObservable() {
        return this.usuarioBehavior.asObservable();
    }

    updateFormattedTime() {
        if (!this.usuario || !this.usuario.token) {
            return '00:00:00';
        }
        const now = Date.now();
        const diffSeconds = Math.max(0, Math.floor(((this.usuario.token.expDate.getTime() as number) - now) / 1000));
        const hours = Math.floor(diffSeconds / 3600);
        const minutes = Math.floor((diffSeconds % 3600) / 60);
        const seconds = diffSeconds % 60;
        this.formattedTime = `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(seconds)}`;
        return this.formattedTime;
    }

    updateInSecods() {
        if (!this.usuario || !this.usuario.token) {
            return 29 * 60;
        }
        const now = Date.now();
        const diffSeconds = Math.max(0, Math.floor(((this.usuario.token.expDate.getTime() as number) - now) / 1000));
        return diffSeconds;
    }

    private pad(value: number): string {
        return value < 10 ? `0${value}` : `${value}`;
    }

    private tokenExpired(token: string) {
        const expiry = (JSON.parse(atob(token.split('.')[1]))).exp;
        return (Math.floor((new Date).getTime() / 1000)) >= expiry;
    }

    async verificarToken() {
        const usuarioLogado = await this.storage.get(this.storageConfig.usuarioLogado);
        return this.tokenExpired(usuarioLogado.token.accessToken);
    }

    async setUsuario(usuario: Usuario) {
        this.usuario = usuario;
        if (usuario) {
            console.log(usuario, "lorem ipsum")
            await this.storage.set(this.storageConfig.usuarioLogado, usuario);
            this.usuarioBehavior.next(usuario);
        } else {
            await this.storage.remove(this.storageConfig.usuarioLogado);
        }
    }

    async load(): Promise<any> {
        const usuario = await this.storage.get(this.storageConfig.usuarioLogado);
        this.setUsuario(usuario);
    }

    public isPerfilGestor(): boolean {
        return this.usuario.menu && !!this.usuario.menu.filter((m) => {
            return m.descricao === 'Gestão';
        }).length;
    }

    public isPerfilEstabelecimento(): boolean {
        if (this.usuario && this.usuario.perfil) {
            return this.usuario.perfil.sigla === 'ESTNS' || this.usuario.perfil.sigla === 'ESTS' || this.usuario.perfil.sigla === 'ESTNSE';
        }
    }

    public isPerfilEstabelecimentoSus(): boolean {
        if (this.usuario && this.usuario.perfil) {
            return this.usuario.perfil.sigla === 'ESTS';
        }
    }

    public isPerfilEstabelecimentoNSus(): boolean {
        if (this.usuario && this.usuario.perfil) {
            return this.usuario.perfil.sigla === 'ESTNS' || this.usuario.perfil.sigla === 'ESTREC' || this.usuario.perfil.sigla === 'ESTNSE';
        }
    }

    public isPerfilDistrital(): boolean {
        if (this.usuario.perfil) {
            return this.usuario.perfil.sigla === 'ADS';
        }
    }

    public isPerfilRegional(): boolean {
        if (this.usuario.perfil) {
            return this.usuario.perfil.sigla === 'ARS';
        }
    }

    public isPerfilMunicipal(): boolean {
        if (this.usuario.perfil) {
            return this.usuario.perfil.sigla === 'MUN_CON' || this.usuario.perfil.sigla === 'ADM_MUN';
        }
    }

    public isPerfiEstadual(): boolean {
        if (this.usuario.perfil) {
            return this.usuario.perfil.sigla === 'ADM_EST' || this.usuario.perfil.sigla === 'EST_CON';
        }
    }

    public isPerfiFederal(): boolean {
        if (this.usuario.perfil) {
            return this.usuario.perfil.sigla === 'ADM_FED' || this.usuario.perfil.sigla === 'FED_CON' || this.usuario.perfil.sigla === 'FED_CON_AG';
        }
    }

    public isPerfilAdmFederal(): boolean {
        if (this.usuario.perfil) {
            return this.usuario.perfil.sigla === 'ADM_FED';
        }
    }
}
